export const TIARA_SECTION_NAME = '구독ON홈';

const AD_TRACK_SERVICE_ORIGIN = 'adtrack_service_origin';
export const TIARA_IMPRESSION_ID = 'product_subscription';
export const TIARA_CUSTOM_PROPS = {
  [AD_TRACK_SERVICE_ORIGIN]: TIARA_IMPRESSION_ID,
};

export const TIARA_PAGE = {
  TRIAL: '써보기',
  DISCOVER: '발견하기',
  PLANNING_DETAIL: '기획전상세',
  BRAND: '찾아보기',
  CATEGORY_DETAIL: '카테고리상세',
  ALL_PLANNING: '전체기획전',
  SEARCH: '검색',
  MY: '마이_개편',
  TARGET_MESSAGE_LANDING_PAGE: '타겟메시지_랜딩페이지',
};
export const TIARA_ACTION_NAME = {
  // Click Event
  TRIAL_PRODUCT_CLICK: '써보기상품목록_클릭',
  PLANNING_CLICK: '기획전목록_클릭',
  CATEGORY_CLICK: '카테고리상품목록_클릭',
  CATEGORY_MORE_CLICK: '카테고리상품목록_더보기_클릭',
  PRODUCT_CLICK: '상품목록_클릭',
  RECOMMEND_PRODUCT_CLICK: '추천상품_클릭',
  RECENT_KEYWORD_CLICK: '최근검색어_클릭',
  SEARCH_BRAND_MORE_CLICK: '검색결과_브랜드더보기_클릭',
  SEARCH_BRAND_FOLD_CLICK: '검색결과_브랜드접기_클릭',
  SEARCH_BRAND_CLICK: '검색결과_브랜드_클릭',
  SEARCH_PRODUCT_CLICK: '검색결과_상품_클릭',
  SEARCH_CLICK: '검색하기_클릭',
  TRIAL_BANNER_CLICK: '써보기_배너_클릭',
  DISCOVER_BANNER_CLICK: '발견하기_배너_클릭',
  PLANNING_DETAIL_BANNER_CLICK: '기획전상세_배너_클릭',
  BRAND_BANNER_CLICK: '브랜드_배너_클릭',
  MY_BANNER_CLICK: '마이_개편_배너_클릭',
  BRAND_CLICK: '브랜드_클릭',
  RECOMMEND_BRAND_CLICK: '추천브랜드_클릭',
  RECOMMEND_BRAND_PRODUCT_CLICK: '추천브랜드_상품_클릭',
  MY_INFO_CLICK: '내정보_클릭',
  MY_SCHEDULE_CLICK: '구독스케줄_클릭',
  MY_SCHEDULE_MORE_CLICK: '구독스케줄_더보기_클릭',
  MY_SCHEDULE_FOLD_CLICK: '구독스케줄_접기_클릭',
  MY_SCHEDULE_POPUP_CLICK: '구독스케줄팝업_클릭',
  MY_SUBSCRIPTION_TAB_CLICK: '구독중탭_클릭',
  MY_SUBSCRIPTION_DONE_TAB_CLICK: '구독완료탭_클릭',
  MY_SUBSCRIPTION_ITEM_CLICK: '개별구독목록_클릭',
  BUTTON_TALK_CONSULTING_CLICK: '톡상담하기_클릭',
  BUTTON_INQUIRY_LAUNCHING_CLICK: '문의하기_클릭',
  BUTTON_CONFIRM_UNSIGNED_CLICK: '미가입팝업_클릭',
  BUTTON_EXPLORE_PRODUCTS_CLICK: '상품보러가기_클릭',

  // View Event
  SEARCH_ENTRY_VIEW: '검색엔트리페이지_보기',
  SEARCH_RESULT_VIEW: '검색결과페이지_보기',
  MY_VIEW: '마이_보기',
  PLANNING_DETAIL_VIEW: '기획전상세_보기',
  CATEGORY_DETAIL_VIEW: '카테고리상세_보기',
  ALL_PLANNING_VIEW: '전체기획전_보기',
  DISCOVER_VIEW: '발견하기_보기',
  TRIAL_VIEW: '써보기_보기',
  BRAND_VIEW: '찾아보기_보기',
  LANDING_PAGE_VIEW: '랜딩페이지_보기',
};
export enum TiaraActionKind {
  VIEW_CONTENT_LIST = 'ViewContentList',
  VIEW_CONTENT = 'ViewContent',
  SEARCH = 'Search',
  VIEW_SEARCH_RESULTS = 'ViewSearchResults',
}
export const TIARA_AREA = {
  TRIAL_TAB: '써보기탭',
  PLANNING: '기획전',
  CATEGORY: '카테고리',
  PLANNING_DETAIL_LIST: '기획전상품목록',
  CATEGORY_PRODUCTS: '카테고리상품목록',
  SEARCH_RECOMMEND_PRODUCT: '검색엔트리_추천상품',
  SEARCH_BRAND: '검색결과_브랜드',
  SEARCH_PRODUCT: '검색결과_상품',
  BRAND_CATEGORY_TAB: '브랜드카테고리탭',
  RECOMMEND_BRAND: '추천브랜드',
  RECOMMEND_BRAND_PRODUCT: '추천브랜드상품목록',
  BANNER_TRIAL: '배너_써보기',
  BANNER_DISCOVER: '배너_발견하기',
  BANNER_PLANNING_DETAIL: '배너_기획전상세',
  BANNER_BRAND: '배너_브랜드',
  BANNER_MYPAGE: '배너_마이페이지',
};
export const TIARA_TYPE = {
  PRODUCT: 'dp_products_id',
  PLANNING: 'planning_id',
  CATEGORY: 'on_category_id',
  STORE_CODE: 'store_code',
  CAMPAIGN: 'campaign_id',
  TARGET_MESSAGE: 'target_message_id',
};
